package frontend.components

import androidx.compose.runtime.Composable
import components.XIcon
import frontend.lib.classList
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.attributes.builders.TextAreaAttrsBuilder
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLButtonElement

@Composable
fun TWTextArea(
    id: String,
    label: @Composable() () -> Unit,
    text: String,
    attrs: TextAreaAttrsBuilder.() -> Unit
) {
    Div() {
        Label(forId = id,
            attrs = {
                classes("block", "text-sm", "font-medium", "text-gray-700")
            }
        ) {
            label()
        }

        Div(attrs = { classes("mt-1") }) {
            TextArea() {
                id(id)
                classes(
                    "shadow-sm", "focus:ring-indigo-500", "focus:border-indigo-500",
                    "block", "w-full", "sm:text-sm", "border-gray-300", "rounded-md",
                    "disabled:bg-slate-50", "disabled:text-slate-500", "disabled:border-slate-200",
                    "disabled:shadow-none", "resize-none"
                )
                value(text)
                name("text")
                rows(4)
                style {
                    borderWidth(1.px)
                    padding(0.5.cssRem, 0.75.cssRem)
                }
                this.attrs()
            }
        }
    }
}

@Composable
fun TWTextArea(
    id: String,
    label: String,
    text: String,
    attrs: TextAreaAttrsBuilder.() -> Unit
) {
    return TWTextArea(
        id,
        { Text(label) },
        text,
        attrs
    )
}

@Composable
fun TWButton(
    label: String,
    attrs: AttrBuilderContext<HTMLButtonElement> = {},
    isLoading: Boolean = false,
    onSubmit: () -> Unit
) {
    return TWButton({ Text(label) }, attrs, isLoading, onSubmit)
}


@Composable
fun TWButton(
    label: @Composable() () -> Unit,
    attrs: AttrBuilderContext<HTMLButtonElement> = {},
    isLoading: Boolean = false,
    onSubmit: () -> Unit
) {
    Button(attrs = {
        classes(
            "inline-flex", "items-center", "px-4", "py-2", "border",
            "border-transparent", "text-sm", "font-medium", "rounded-md",
            "shadow-sm", "text-white", "bg-indigo-600", "hover:bg-indigo-700",
            "focus:outline-none", "focus:ring-2", "focus:ring-offset-2", "focus:ring-indigo-500"
        )
        onClick { onSubmit() }
        type(ButtonType.Submit)
        attrs()
    }) {
        if (isLoading) {
            // TODO: add svg?
            Text("Processing...")
        }
        else label()
    }
}

@Composable
fun TWSubmitButton(
    label: String,
    attrs: AttrBuilderContext<HTMLButtonElement> = {},
    isLoading: Boolean = false,
    onSubmit: () -> Unit
) {
    Div() {
        Button(attrs = {
            classes(
                "w-full", "flex", "justify-center", "py-2", "px-4",
                "border", "border-transparent",
                "rounded-md", "shadow-sm", "text-sm", "font-medium",
                "text-white", "bg-indigo-600", "hover:bg-indigo-700",
                "focus:outline-none", "focus:ring-2", "focus:ring-offset-2",
                "focus:ring-indigo-500"
            )
            onClick { onSubmit() }
            type(ButtonType.Submit)
            attrs()
        }) {
            if (isLoading) {
                // TODO: add svg?
                Text("Processing...")
            }
            else Text(label)
        }
    }
}

@Composable
fun TWForm(
    attrs: AttrBuilderContext<*> = {},
    content: @Composable () -> Unit = {}
) {
    Form(
        attrs = {
            classes("space-y-6")
            method(FormMethod.Post)
            action("javascript:void(0);")
        }
    ) {
        content()
    }
}

@Composable
fun RoundedForm(
    attrs: AttrBuilderContext<*> = {},
    content: @Composable () -> Unit = {}
) {
    Div(attrs = {
        classes("mt-8", "sm:mx-auto", "sm:w-full", "sm:max-w-md")
        attrs()
    }) {
        Div(attrs = { classes("bg-white", "py-8", "px-4", "shadow", "sm:rounded-lg", "sm:px-10") }) {
            Form(
                attrs = {
                    classes("space-y-6")
                    method(FormMethod.Post)
                    action("javascript:void(0);")
                }
            ) {
                content()
            }
        }
    }
}

@Composable
fun Modal(
    onClose: () -> Unit = {},
    showX: Boolean = true,
    size: String = "sm:max-w-lg",
    content: @Composable () -> Unit = {}
) {
    Div(attrs = {
        classList("fixed z-10 inset-0 overflow-y-auto")
        attr("aria-labelledby", "modal-title")
        attr("role", "dialog")
        attr("aria-modal", "true")
    }) {
        Div(attrs = {
            classList("flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0")
        }) {
            Div(attrs = {
                classList("fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity")
                attr("aria-hidden", "true")
            })

            Span(attrs = {
                classList("hidden sm:inline-block sm:align-middle sm:h-screen")
                attr("aria-hidden", "true")
            }) { Text('\u200B'.toString()) }

            Div(attrs = { classList("inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle ${size} sm:w-full sm:p-6") }) {
                if (showX) Div(attrs = { classList("hidden sm:block absolute top-0 right-0 pt-4 pr-4") }) {
                   Button(attrs = {
                       classList("bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500")
                       type(ButtonType.Button)
                       onClick { onClose() }
                   }) {
                       Span(attrs = { classList("sr-only")}) { Text("Close") }
                       XIcon()
                   }
                }

                content()
            }
        }
    }
}